require('./bootstrap');

import * as utils from './helpers';
window.utils = utils;
